import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

import {HandoverModel} from "@handover/view-models/handover.model";

@Component({
  selector: 'handoverm-handover-header',
  templateUrl: './handover-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverHeaderComponent implements OnInit {

  @Input() model?: HandoverModel;
  @Input() fromOrToDriverTrans = '';

  constructor() {
  }

  ngOnInit(): void {
  }

}
